import { forwardRef } from "react";
import { Link, type LinkProps } from "react-router-dom";

export const StyledLink = forwardRef<
  HTMLAnchorElement,
  LinkProps & { tabIndex?: number; className?: string }
>(({ tabIndex = 0, className, ...props }, ref) => (
  <Link
    ref={ref}
    tabIndex={tabIndex}
    className={`text-[#1453f5] no-underline [@supports(-webkit-hyphens:none)_and_(not(-ms-ime-align:auto))]:focus:outline [@supports(-webkit-hyphens:none)_and_(not(-ms-ime-align:auto))]:focus:outline-[3px_solid_Highlight] [@supports(-webkit-hyphens:none)_and_(not(-ms-ime-align:auto))]:focus:outline-offset-[3px] [@supports(-webkit-hyphens:none)_and_(not(-ms-ime-align:auto))]:focus-visible:outline [@supports(-webkit-hyphens:none)_and_(not(-ms-ime-align:auto))]:focus-visible:outline-[3px_solid_Highlight] [@supports(-webkit-hyphens:none)_and_(not(-ms-ime-align:auto))]:focus-visible:outline-offset-[3px] ${className ?? ""}`}
    {...props}
  />
));
